import React from 'react';
import {graphql} from 'gatsby';

import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';
import SEO from '../components/seo';

const ZespolyWeselne = ({data}) => {

    const zespol1Photo = data.zespol1.childImageSharp.fluid;
    const zespol2Photo = data.zespol2.childImageSharp.fluid;   


    const titleText = "Zespoły weselne";
    const paragraphText = "Szukasz zespołu na wesele? To tylko kilka z naszych propozycji. Skontaktuj się z nami a dobierzemy pod Ciebie wykonawcę idealnego."; 
    const bgimage = data.zespolybg.childImageSharp.fluid;
  
    const content = [
      {
        title: "Zespół 1",
        text: "Doskonały zespół na wesele, który wykona największe hity ostatnich 40 lat. Wszystko w jak najwyższym stylu wykonawczym podane w smoothrock and popowym sosie. Doświadczony, istniejący na polskim rynku muzycznym od lat coverband rozkręci zabawę na najwyższym poziomie zaskakując gości najnowszymi hitami jak i klasycznymi tanecznymi szaleństwami z lat 70 i 80.",
        image: zespol1Photo,
        alt: "Zespół 1",
        link: "https://vimeo.com/292300617",
        target: "yes"
      },
      {
        title: "Zespół 2", 
        text: "Zespół weselny dla gości, którzy uwielbiają koncerty i żywą muzykę podaną w rytmicznej interpretacji. Kolektyw złożony z wykształconych muzycznie, młodych i energicznych osób. Ich repertuar oscyluje w okół ostatnich 30 lat. Wykonują największe hity zagraniczne i polskie sprawiając, że każdy z gości wyjdzie zadowolony z Państwa uroczystości.",
        image: zespol2Photo,
        alt: "Zespół 2",
        link: "https://vimeo.com/292291405",
        target: "yes"
      },
    ];

    return (
        <>  
          <SEO title="Zespoły weselne"/>
            <Header link={bgimage}/>
            <SectionWrapper content={content} title={titleText} text={paragraphText} resize="yes"/>
        </>
    )
};

export const query = graphql`
    {
        zespol1: file(name: {eq: "zespol1"}) {
            childImageSharp {
              fluid(quality: 90) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        zespol2: file(name: {eq: "zespol3"}) {
            childImageSharp {
                fluid(quality: 90) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        noimage: file(name: {eq: "noimage"}) {
            childImageSharp {
                fluid(quality: 90) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        zespolybg: file(name: {eq: "Zespoly01"}) {
          childImageSharp {
              fluid(quality: 90) {
                  ...GatsbyImageSharpFluid_tracedSVG
              }
          }
      }
    }
`;

export default ZespolyWeselne